module.exports = __webpack_public_path__ + "img/more.f9d6388e.svg";